//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

import { facebookInstagramSettingsActions } from '@account-settings/redux/facebook-instagram/facebookInstagramSettingsActions';
import { IDefaultInstagramAccount } from '@instagram-account/redux/account/instagramAccountModel';
import {
  receiveDefaultInstagramAccountFailed,
  receiveDefaultInstagramAccountSucceeded,
  requestDefaultInstagramAccount,
} from '@instagram-account/redux/account/instagramAccountSlice';
import { createThunk } from '@redux/createThunk';
import * as instagramUserApi from '@apis/instagram-user/instagramUserApi';
import { getRequestErrorMessage } from '@utils/getRequestErrorMessage';

/**
 * We separate this action out into its own file so there is no implicit dependency on Angular services
 * when it is imported. This allows us to call it more safely in pure React contexts such as the schedule export.
 */
export const fetchDefaultInstagramAccount = createThunk(
  () => async (dispatch) => {
    dispatch(requestDefaultInstagramAccount());

    try {
      const [connectedAccount, graphApiDefaultAccount] = await Promise.all([
        dispatch(
          facebookInstagramSettingsActions.fetchConnectedInstagramAccount(),
        ),
        instagramUserApi.getDefaultInstagramUser(),
      ]);

      if (connectedAccount && graphApiDefaultAccount) {
        // Until we clear out all usages of the defaultAccount fields throughout the dashboard,
        // just mirror the shape of the old default account so that the data is where we expect.
        const defaultAccount: IDefaultInstagramAccount = {
          ...graphApiDefaultAccount.user,
          userId: connectedAccount.userId,
          accountId: connectedAccount.userId,
        };

        dispatch(
          receiveDefaultInstagramAccountSucceeded({
            defaultInstagramAccount: defaultAccount,
            businessAccountId: connectedAccount.businessAccountId,
          }),
        );
      }
    } catch (e) {
      dispatch(
        receiveDefaultInstagramAccountFailed(
          getRequestErrorMessage(e) ??
            'Failed to fetch default Instagram Account',
        ),
      );
    }
  },
);
